import type { NotificationSourceSourceUser } from './notificationSourceSourceUser';

export interface NotificationSource {
  sourceUser?: NotificationSourceSourceUser;
  /** @nullable */
  sourceUserId?: number | null;
}
